import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { useJoinVisible } from '../../hooks/useJoinVisible';
import { CLUB, TRADEMARK_NOTE } from '../../utils/constants';

export default function Footer() {
  const joinVisible = useJoinVisible();

  return (
    <footer className="mt-footer">
      <div className="mt-container">
        <div className="mt-footer__top">
          <div>
            <Logo className="mt-logo--sm" />
            <p className="mt-footer__claim">{CLUB.claim}</p>
          </div>

          <nav className="mt-footer__links" aria-label="Footer-Navigation">
            <Link to="/termine">Termine</Link>
            <Link to="/galerie">Galerie</Link>
            {joinVisible && <Link to="/mitglied-werden">Mitglied werden</Link>}
            <a href={CLUB.instagram} target="_blank" rel="noopener noreferrer">
              Instagram
            </a>
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
          </nav>
        </div>

        <p className="mt-footer__note">{TRADEMARK_NOTE}</p>

        <p className="mt-footer__copy">
          © {new Date().getFullYear()} {CLUB.name}
        </p>
      </div>
    </footer>
  );
}
